if (!customElements.get('approval-options')) {
    class ApprovalOptions extends HTMLElement {

        constructor() {
            super();
            this.key = this.dataset.key;
            this.item = JSON.parse(document.querySelector(`[data-item="${this.key}"]`)?.innerText);
            this.radioSelectChangeInput = this.querySelector(`.line-item-action`);
            this._selectedOption = null;
        }

        connectedCallback() {

            const radioSelect = document.querySelector(`[data-radio-select="${this.key}"]`);

            if (radioSelect) {
                this._selectedOption = radioSelect.value;
            }

            this.radioSelectChangeInput.addEventListener('change', this.handleRadioChanged.bind(this));
        }

        disconnectedCallback() {
            this.radioSelectChangeInput.removeEventListener('change', this.handleRadioChanged.bind(this));
        }

        get selectedOption() {
            return this._selectedOption;
        }

        set selectedOption(value) {

            if (value == this._selectedOption && this._selectedOption == 'ALTERNATIVE') {
                this.changeOption('CANCELLATION');
                return;
            }

            if (value == this._selectedOption) return;

            this._selectedOption = value;

            if (value == 'ALTERNATIVE') {
                this.showAlternatives();
            } else {
                this.hideAlternatives();
            }

            // this.changeOption(value);
        }

        handleRadioChanged({ target }) {
            this.selectedOption = target.value;
        }

        changeOption(option) {
            document.querySelector(`[name="${this.key}"][value="${option}"]`).checked = true;
            this.radioSelectChangeInput.value = option;
            this.radioSelectChangeInput.dispatchEvent(new Event('change'));
        }

        hideAlternatives() {
            const row = document.querySelector(`.alternative-cart-item[data-line-item-key="${this.item.key}"]`);
            if (row) row.classList.remove('selected');
        }

        showAlternatives() {
            const row = document.querySelector(`.alternative-cart-item[data-line-item-key="${this.item.key}"]`);
            if (row) row.classList.add('selected');
        }
    }

    customElements.define('approval-options', ApprovalOptions);
}